import { render, staticRenderFns } from "./SocialMediaSharing.vue?vue&type=template&id=22be395a&"
import script from "./SocialMediaSharing.vue?vue&type=script&lang=js&"
export * from "./SocialMediaSharing.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaSharing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports